import { useMutation } from 'react-query';
import { apiPost } from './apiService';

interface AuditParams {
  actionType: string;
  domainId: number;
  domainType: string;
}

const addAudit = ({ actionType, domainId, domainType }: AuditParams): Promise<void> => {
  return apiPost(`audit/`, { actionType, domainId, domainType });
};

const useAuditMutation = () => {
  return useMutation({
    mutationFn: addAudit,
    mutationKey: ['useAuditMutation']
  });
};

export default useAuditMutation;
